import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LoadingSpinner = ({ size = 'md', text }) => {
    const { t } = useTranslation('common');
    const displayText = text === undefined ? t('loading') : text;
    const sizes = {
        sm: 'w-4 h-4',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
    };

    return (
        <div className="flex flex-col items-center justify-center py-12">
            <Loader2 className={`${sizes[size]} animate-spin text-primary-600`} />
            {displayText && <p className="mt-3 text-gray-600">{displayText}</p>}
        </div>
    );
};
